import Keycloak from 'keycloak-js';
import { env } from './env';

// Keycloak configuration
const keycloakConfig = {
  url: env.VITE_KEYCLOAK_URL,
  realm: env.VITE_KEYCLOAK_REALM,
  clientId: env.VITE_KEYCLOAK_CLIENT_ID,
};

// Initialize Keycloak instance
const keycloak = new Keycloak(keycloakConfig);

// Initialize Keycloak with options
export const initKeycloak = async (
  onAuthenticatedCallback: () => void,
  onErrorCallback?: (error: Error) => void
) => {
  try {
    const authenticated = await keycloak.init({
      onLoad: 'login-required',
      checkLoginIframe: true,
      pkceMethod: 'S256',
    });

    console.log('Keycloak initialized, authenticated:', authenticated);

    if (authenticated) {
      console.log('User authenticated, rendering app');
      onAuthenticatedCallback();

      // Auto-refresh token
      setInterval(() => {
        keycloak.updateToken(70).catch(() => {
          console.error('Failed to refresh token');
          keycloak.login();
        });
      }, 60000); // Check every minute
    }
    // login-required 모드에서는 authenticated가 false면 이미 로그인 페이지로 리다이렉트됨
  } catch (error) {
    console.error('Failed to initialize Keycloak', error);
    if (onErrorCallback) {
      onErrorCallback(error instanceof Error ? error : new Error(String(error)));
    }
  }
};

// Get access token
export const getToken = async (): Promise<string | undefined> => {
  try {
    await keycloak.updateToken(5);
    return keycloak.token;
  } catch {
    await keycloak.login();
    return undefined;
  }
};

// Logout
export const doLogout = () => {
  keycloak.logout();
};

// Get user profile
export const getUsername = () => keycloak.tokenParsed?.preferred_username;
export const getUserEmail = () => keycloak.tokenParsed?.email;
export const getUserId = () => keycloak.tokenParsed?.sub;

export default keycloak;
